import { isNil, Nillable } from '@web/utils';
import { CollectionFilterKey } from '../../collection/types/collection-filter-key';
import { CollectionFilterOperator } from '../enums/collection-filter-operator';
import { CollectionFilterRequest } from '../requests/collection-filter.request';
import { RequiredMethodCallException } from '../../exceptions/required-method-call.exception';
import { CollectionFilterValue } from '../../collection/types/collection-filter-value';

export abstract class BaseCollectionFilterRequestBuilder<Filter> {
  protected _operator: Nillable<CollectionFilterOperator>;
  protected _value: Nillable<CollectionFilterValue>;
  protected _property: Nillable<CollectionFilterKey<Filter>>;

  public value(value: Nillable<CollectionFilterValue>): this {
    this._value = value;

    return this;
  }

  public property(property: CollectionFilterKey<Filter>): this {
    this._property = property;

    return this;
  }

  public reset(): this {
    this._operator = null;
    this._value = null;
    this._property = null;

    return this;
  }

  public build(): Nillable<CollectionFilterRequest> {
    this.validate();

    if (isNil(this._value)) {
      this.reset();

      return null;
    }

    const result = new CollectionFilterRequest(
      this._property! as string,
      this._value!,
      this._operator!,
    );

    this.reset();

    return result;
  }

  protected validate(): void {
    this.requireProperty();
  }

  protected operator(operator: CollectionFilterOperator): this {
    this._operator = operator;

    return this;
  }

  protected requireProperty(): void {
    if (isNil(this._property)) {
      throw new RequiredMethodCallException(this.property.name);
    }
  }
}
